// V1 has key saveData
export const filterOutV1 = (projects: IProjects = {}): IProjects => {
  return Object.values(projects).reduce((acc, project) => {
    if ('saveData' in project) {
      return acc;
    }
    return { ...acc, [project.id]: project };
  }, {});
};
